import { setApplicationError } from '../stores/app-state-store';
import {
  consumeHandoffSessionSuccess,
  createHandoffSessionSuccess,
  handoffSessionSlice,
  setHandoffSession,
} from '../stores/handoff-session-store';
import { CreateUrlHandoffSessionRequest } from '../lib-api/services/HandoffSession';
import {
  ERR_HANDOFF_CREATE_SESSION,
  ERR_HANDOFF_SESSION_FAILED_CONSUME_SESSION,
  ERR_HANDOFF_SESSION_FAILED_GET_SESSION,
  handoffSessionClient,
  HandoffSessionClient,
} from '../connectivity/services/handoffSessionService';
import { ServiceDispatch } from './types';

export type HandoffSessionDispatch = ServiceDispatch<typeof handoffSessionSlice.actions>;

type ConsumeUrlHandoffSessionThunk = (dispatch: HandoffSessionDispatch) => Promise<void>;
type GetHandoffSessionThunk = (dispatch: HandoffSessionDispatch) => Promise<void>;
type CreateHandoffSessionThunk = (dispatch: HandoffSessionDispatch) => Promise<void>;

export interface HandoffSessionService {
  createUrlHandoffSession: (payload: CreateUrlHandoffSessionRequest) => CreateHandoffSessionThunk;
  consumeUrlHandoffSession: (handoffSessionId: string) => ConsumeUrlHandoffSessionThunk;
  getHandoffSession: (handoffSessionId: string) => GetHandoffSessionThunk;
}

/**
 * @deprecated
 * due to SDK-3315 TinkLink Scaling project
 * use handoffSessionService instead
 */
export function createHandoffSessionService(client: HandoffSessionClient): HandoffSessionService {
  return {
    consumeUrlHandoffSession: (handoffSessionId) => async (dispatch) => {
      const response = await client.consumeHandoffSession({ handoffSessionId });

      if (response.isOk() && response.data) {
        dispatch(consumeHandoffSessionSuccess(response.data));
      } else {
        dispatch(setApplicationError(ERR_HANDOFF_SESSION_FAILED_CONSUME_SESSION));
      }
    },
    getHandoffSession: (handoffSessionId) => async (dispatch) => {
      const response = await client.getHandoffSession({ handoffSessionId });

      if (response.isOk() && response.data) {
        dispatch(setHandoffSession(response.data));
      } else {
        dispatch(setApplicationError(ERR_HANDOFF_SESSION_FAILED_GET_SESSION));
      }
    },
    createUrlHandoffSession: (payload) => async (dispatch) => {
      const response = await client.createUrlHandoffSession(payload);

      if (response.isOk() && response.data) {
        dispatch(createHandoffSessionSuccess(response.data));
      } else {
        dispatch(setApplicationError(ERR_HANDOFF_CREATE_SESSION));
      }
    },
  };
}

export const handoffSessionService = createHandoffSessionService(handoffSessionClient);
